import { onBeforeRouteLeave } from 'vue-router';
import { useRouteHelperStore } from '../../pinia/RouteHelperStore';
import { computed} from 'vue';
export function saveLeave(){
    const RouteHelperStore = useRouteHelperStore();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onBeforeRouteLeave((to, from) => {
        if(RouteHelperStore.isDirty == true && RouteHelperStore.saveAllowed){
            // RouteHelperStore.show = true;
            // RouteHelperStore.to = to;
            // return false;
            RouteHelperStore.initialState = {};
        }else{
            RouteHelperStore.initialState = {};
        }
    })
}

export function isDirty(){
    const RouteHelperStore = useRouteHelperStore();
    const isDirty = computed(() => {
        return RouteHelperStore.isDirty;
    });
    return isDirty;
}

export function setInitial(data, uniqnes = ""){
    if(!data || data == undefined){
        return;
    }
    const RouteHelperStore = useRouteHelperStore();
    if(uniqnes == ""){
        RouteHelperStore.setInitialState(data);
    }else{
        var tmp = JSON.parse(JSON.stringify(RouteHelperStore.initialState));
        tmp[uniqnes] = JSON.parse(JSON.stringify(data));
        RouteHelperStore.setInitialState(tmp);
    }

}
export function reValidate(data, uniqnes = ""){
    const RouteHelperStore = useRouteHelperStore();
    if(uniqnes == ""){
        RouteHelperStore.validateData(data);
    }else{
        var tmp = JSON.parse(JSON.stringify(RouteHelperStore.initialState));
        tmp[uniqnes] = JSON.parse(JSON.stringify(data));
        RouteHelperStore.validateData(tmp);
    }
}
export function dropUniq(uniqnes){
    const RouteHelperStore = useRouteHelperStore();
    var tmp = JSON.parse(JSON.stringify(RouteHelperStore.initialState));
    delete tmp[uniqnes];
    RouteHelperStore.setInitialState(tmp);
}
